import React, { useEffect } from 'react';
import { ChakraProvider, Box, Container, Heading, Text, VStack, HStack, Flex, Stack, Badge, Divider, Image } from '@chakra-ui/react';
import { AlertTriangleIcon, CheckIcon, XIcon, ClockIcon, LockIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingTable } from './components/PricingTable';
import { TestimonialCard } from './components/TestimonialCard';
import { CTAButton } from './components/CTAButton';
import { GuaranteeSection } from './components/GuaranteeSection';
import { PurchaseNotification } from './components/PurchaseNotification';
export function App() {
  useEffect(() => {
    // Set page title
    document.title = 'Conjuro de los 7 Poderes Ancestrales del Amor';
  }, []);
  const handleCTAClick = () => {
    // Track InitiateCheckout event with Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Conjuro de los 7 Poderes Ancestrales',
        content_category: 'Digital Product',
        value: 9.99,
        currency: 'USD'
      });
    }
    // Redirect to Shopify checkout
    window.open('https://www.tiendasamazonica.com/cart/50969265242397:1', '_blank');
  };
  const handleScrollToSection = () => {
    // Scroll to the second section (BLOQUE 2)
    const secondSection = document.getElementById('bloque-2-image');
    if (secondSection) {
      secondSection.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <ChakraProvider data-id="element-0">
      <Box bg="black" minH="100vh" w="full" data-id="element-1">
        {/* Purchase Notification */}
        <PurchaseNotification data-id="element-2" />

        {/* BLOQUE 1 — URGENCIA + GANCHO INICIAL */}
        <Box bg="red.700" py={3} position="sticky" top={0} zIndex={1000} shadow="2xl" borderBottom="2px solid" borderColor="red.500" data-id="element-3">
          <Container maxW="container.xl" data-id="element-4">
            <Flex align="center" justify="space-between" gap={4} flexWrap="wrap" direction={{
            base: 'column',
            md: 'row'
          }} data-id="element-5">
              <Flex align="center" gap={2} data-id="element-6">
                <AlertTriangleIcon color="white" size={20} data-id="element-7" />
                <Text color="white" fontWeight="bold" fontSize={{
                base: 'xs',
                md: 'sm'
              }} textAlign="center" data-id="element-8">
                  OFERTA EXPIRA EN:
                </Text>
              </Flex>

              <CountdownTimer compact={true} data-id="element-9" />
            </Flex>
          </Container>
        </Box>

        <Container maxW="container.lg" py={8} data-id="element-10">
          <VStack spacing={8} align="stretch" data-id="element-11">
            {/* Hero Section with Background Image */}
            <Box position="relative" borderRadius="2xl" overflow="hidden" minH="600px" data-id="element-12">
              {/* Background Image with Overlay */}
              <Box position="absolute" top={0} left={0} right={0} bottom={0} bgImage="url('https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=1200&q=80')" bgSize="cover" bgPosition="center" _after={{
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              bg: 'linear-gradient(135deg, rgba(127, 29, 29, 0.95) 0%, rgba(0, 0, 0, 0.9) 100%)'
            }} data-id="element-13" />

              {/* Content */}
              <VStack spacing={6} textAlign="center" py={12} px={6} position="relative" zIndex={1} data-id="element-14">
                <Heading as="h1" fontSize={{
                base: '4xl',
                md: '6xl'
              }} fontWeight="black" color="#FFFFFF" lineHeight="shorter" textShadow="0 6px 20px rgba(0,0,0,0.9), 0 0 40px rgba(255, 255, 255, 0.3), 0 0 60px rgba(255, 255, 255, 0.2)" letterSpacing="tight" position="relative" filter="brightness(1.2)" _after={{
                content: '""',
                position: 'absolute',
                bottom: '-10px',
                left: '50%',
                transform: 'translateX(-50%)',
                width: '80%',
                height: '4px',
                bg: 'linear-gradient(90deg, transparent, #FFFFFF, transparent)',
                borderRadius: 'full',
                boxShadow: '0 0 20px rgba(255, 255, 255, 0.5)'
              }} data-id="element-15">
                  ¿Cuánto tiempo más vas a esperar que esa persona vuelva sola?
                </Heading>

                <Text fontSize={{
                base: 'lg',
                md: 'xl'
              }} color="red.100" maxW="3xl" lineHeight="tall" textShadow="0 2px 8px rgba(0,0,0,0.8)" data-id="element-16">
                  Más de 1.144 personas ya usaron este ritual ancestral del
                  Darién para recuperar el amor — y vieron señales en menos de
                  72 horas.
                </Text>

                <Text fontSize="2xl" fontWeight="bold" color="yellow.300" textShadow="0 2px 8px rgba(0,0,0,0.8)" data-id="element-17">
                  Hoy es tu turno.
                </Text>

                {/* Audio Player */}
                <Box w="full" maxW="600px" bg="linear-gradient(135deg, rgba(127, 29, 29, 0.4) 0%, rgba(0, 0, 0, 0.6) 100%)" p={5} borderRadius="xl" borderWidth="2px" borderColor="red.500" backdropFilter="blur(10px)" shadow="2xl" data-id="element-18">
                  <VStack spacing={2} data-id="element-19">
                    <Text fontSize="sm" color="yellow.300" fontWeight="semibold" data-id="element-20">
                      🎧 Escucha el mensaje del ritual
                    </Text>
                    <audio controls style={{
                    width: '100%',
                    height: '45px',
                    borderRadius: '8px'
                  }} data-id="element-21">
                      <source src="https://ydgkmdmvhrniztrhtrxq.supabase.co/storage/v1/object/sign/audio%20receta/Untitle6%20(1).mp3?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV80NDNkYTY1ZS1iYWM1LTQyYWQtODMzNS1iNWE4N2M0NDYxNmQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJhdWRpbyByZWNldGEvVW50aXRsZTYgKDEpLm1wMyIsImlhdCI6MTc3MTg1NjExMCwiZXhwIjoxODAzMzkyMTEwfQ.xn4Id7Pbge6Q5qwZo6rbhzPn1Lg3XhNT4rPedW_lioo" type="audio/mpeg" data-id="element-22" />
                      Tu navegador no soporta el elemento de audio.
                    </audio>
                  </VStack>
                </Box>

                {/* CTA Button to scroll to second section */}
                <CTAButton onClick={handleScrollToSection} bg="linear-gradient(135deg, #DC2626 0%, #991B1B 100%)" color="white" borderColor="red.400" shadow="0 0 30px rgba(220, 38, 38, 0.6), 0 8px 16px rgba(0, 0, 0, 0.3)" _hover={{
                bg: 'linear-gradient(135deg, #991B1B 0%, #7F1D1D 100%)',
                transform: 'scale(1.05)',
                shadow: '0 0 40px rgba(220, 38, 38, 0.8), 0 12px 24px rgba(0, 0, 0, 0.4)',
                borderColor: 'red.300'
              }} _active={{
                bg: 'linear-gradient(135deg, #7F1D1D 0%, #450A0A 100%)',
                transform: 'scale(0.98)'
              }} fontSize={{
                base: 'md',
                md: 'lg'
              }} fontWeight="black" textTransform="uppercase" letterSpacing="wide" data-id="element-23">
                  👇 DESCUBRE POR QUÉ FUNCIONA
                </CTAButton>

                <Box bg="rgba(220, 38, 38, 0.2)" p={4} borderRadius="lg" borderWidth="2px" borderColor="red.500" backdropFilter="blur(10px)" data-id="element-24">
                  <Text fontSize="xl" fontWeight="bold" color="white" data-id="element-25">
                    💥 Precio especial activo SOLO HOY —{' '}
                    <Text as="span" textDecoration="line-through" color="gray.400" data-id="element-26">
                      $20 USD
                    </Text>{' '}
                    →{' '}
                    <Text as="span" color="yellow.300" data-id="element-27">
                      $9.99 USD
                    </Text>
                  </Text>
                </Box>
              </VStack>
            </Box>

            {/* BLOQUE 2 — DOLOR + AGITACIÓN EMOCIONAL */}
            <Box bg="linear-gradient(135deg, #1F1F1F 0%, #000000 100%)" p={8} borderRadius="xl" shadow="2xl" borderWidth="1px" borderColor="red.900" data-id="element-28">
              <Flex direction={{
              base: 'column',
              md: 'row'
            }} gap={8} align="center" data-id="element-29">
                {/* Image Section with ID */}
                <Box id="bloque-2-image" flex={{
                base: '1',
                md: '0 0 300px'
              }} w={{
                base: '100%',
                md: '300px'
              }} data-id="element-30">
                  <Image src="https://cdn.magicpatterns.com/uploads/irjAnL4YuL1j3vwU4gjr5t/ChatGPT_Image_23_feb_2026,_10_13_55_a.m..png" alt="Mujer triste pensando en el amor perdido" borderRadius="xl" shadow="2xl" objectFit="cover" w="full" h={{
                  base: '300px',
                  md: '400px'
                }} filter="grayscale(20%) brightness(0.8)" borderWidth="2px" borderColor="red.800" data-id="element-31" />
                </Box>

                {/* Content Section */}
                <VStack spacing={6} align="stretch" flex="1" data-id="element-32">
                  <Heading as="h2" fontSize={{
                  base: '2xl',
                  md: '3xl'
                }} color="white" data-id="element-33">
                    💔 Sé exactamente lo que estás sintiendo ahora mismo.
                  </Heading>

                  <Text fontSize="lg" color="red.200" lineHeight="tall" data-id="element-34">
                    Hay un peso que no desaparece.
                  </Text>

                  <Text fontSize="md" color="gray.300" lineHeight="tall" data-id="element-35">
                    Lo cargas al despertar. Lo cargas al acostarte. Revisas su
                    perfil sin querer hacerlo. Recuerdas una frase, una mirada,
                    un momento… y duele como si hubiera pasado hoy.
                  </Text>

                  <Text fontSize="lg" fontWeight="semibold" color="white" mt={4} data-id="element-36">
                    Lo intentaste todo:
                  </Text>

                  <VStack spacing={3} align="stretch" pl={4} data-id="element-37">
                    <HStack spacing={3} align="start" data-id="element-38">
                      <XIcon size={20} color="#DC2626" strokeWidth={3} data-id="element-39" />
                      <Text color="gray.300" data-id="element-40">
                        Le escribiste con el corazón en la mano… y el silencio
                        fue la respuesta
                      </Text>
                    </HStack>
                    <HStack spacing={3} align="start" data-id="element-41">
                      <XIcon size={20} color="#DC2626" strokeWidth={3} data-id="element-42" />
                      <Text color="gray.300" data-id="element-43">
                        Te alejaste para "darle espacio"… y ese espacio se
                        convirtió en distancia
                      </Text>
                    </HStack>
                    <HStack spacing={3} align="start" data-id="element-44">
                      <XIcon size={20} color="#DC2626" strokeWidth={3} data-id="element-45" />
                      <Text color="gray.300" data-id="element-46">
                        Pediste consejos, rezaste, esperaste señales… y nada
                        cambió
                      </Text>
                    </HStack>
                    <HStack spacing={3} align="start" data-id="element-47">
                      <XIcon size={20} color="#DC2626" strokeWidth={3} data-id="element-48" />
                      <Text color="gray.300" data-id="element-49">
                        Intentaste olvidar… pero esa persona sigue ocupando cada
                        rincón de tu mente
                      </Text>
                    </HStack>
                  </VStack>

                  <Box bg="rgba(127, 29, 29, 0.3)" p={6} borderRadius="lg" borderLeftWidth="4px" borderLeftColor="red.500" mt={4} data-id="element-50">
                    <Text fontSize="lg" fontWeight="bold" color="red.300" mb={2} data-id="element-51">
                      Y lo peor no es el dolor.
                    </Text>
                    <Text fontSize="md" color="gray.300" data-id="element-52">
                      Lo peor es la sensación de que el tiempo pasa… y esa
                      persona se aleja un poco más cada día que no haces nada.
                    </Text>
                  </Box>

                  <Text fontSize="xl" fontWeight="bold" color="red.400" textAlign="center" mt={4} data-id="element-53">
                    La pregunta no es si amas a esa persona. La pregunta es:
                    ¿cuánto más vas a esperar antes de actuar?
                  </Text>
                </VStack>
              </Flex>
            </Box>

            {/* BLOQUE 3 — MECANISMO ÚNICO + ORIGEN DEL RITUAL */}
            <Box bg="linear-gradient(135deg, #7F1D1D 0%, #000000 100%)" p={8} borderRadius="xl" shadow="2xl" borderWidth="1px" borderColor="red.700" data-id="element-54">
              <VStack spacing={6} align="stretch" data-id="element-55">
                <Heading as="h2" fontSize={{
                base: '2xl',
                md: '3xl'
              }} color="white" data-id="element-56">
                  ✨ La razón por la que nada ha funcionado no es lo que crees.
                </Heading>

                <Text fontSize="lg" color="red.100" lineHeight="tall" data-id="element-57">
                  No es falta de amor. No es falta de esfuerzo. No es que "no
                  era para ti".
                </Text>

                <Text fontSize="lg" fontWeight="semibold" color="yellow.300" data-id="element-58">
                  Es que todas las soluciones que intentaste trabajan en la
                  superficie.
                </Text>

                <Text fontSize="md" color="gray.200" lineHeight="tall" data-id="element-59">
                  Los mensajes, los consejos, el tiempo… actúan sobre lo
                  visible. Pero la conexión entre dos personas no vive en lo
                  visible. Vive en el plano energético y emocional profundo.
                </Text>

                <Box bg="rgba(0, 0, 0, 0.6)" p={6} borderRadius="lg" shadow="xl" borderWidth="2px" borderColor="red.500" data-id="element-60">
                  <Text fontSize="xl" fontWeight="bold" color="white" textAlign="center" data-id="element-61">
                    Y ahí es exactamente donde trabaja el Conjuro de los 7
                    Poderes Ancestrales.
                  </Text>
                </Box>

                <Divider borderColor="red.800" data-id="element-62" />

                <VStack spacing={4} align="stretch" data-id="element-63">
                  <Text fontSize="lg" fontWeight="semibold" color="white" data-id="element-64">
                    Este ritual no nació en internet. Tiene siglos de historia.
                  </Text>

                  <Text fontSize="md" color="gray.200" lineHeight="tall" data-id="element-65">
                    Viene de una tradición chamánica ancestral del Darién — una
                    de las regiones energéticamente más poderosas y antiguas del
                    continente americano.
                  </Text>

                  <Text fontSize="md" color="gray.200" lineHeight="tall" data-id="element-66">
                    Durante generaciones, este conocimiento fue guardado y
                    transmitido únicamente entre iniciados. No estaba al alcance
                    de todos. Era reservado para quienes realmente necesitaban
                    despertar un vínculo emocional dormido.
                  </Text>

                  <Box bg="rgba(220, 38, 38, 0.2)" p={4} borderRadius="lg" borderWidth="2px" borderColor="red.500" data-id="element-67">
                    <Text fontSize="lg" fontWeight="bold" color="yellow.300" textAlign="center" data-id="element-68">
                      Hoy, por primera vez, está al alcance de tus manos.
                    </Text>
                  </Box>
                </VStack>

                <Box mt={6} data-id="element-69">
                  <PricingTable rows={[{
                  label: '✅ Trabaja directamente en el plano energético y emocional profundo',
                  value: ''
                }, {
                  label: '✅ No necesitas experiencia previa ni conocimientos esotéricos',
                  value: ''
                }, {
                  label: '✅ Se realiza desde casa, con materiales 100% caseros',
                  value: ''
                }, {
                  label: '✅ Resultados reportados en tan solo 72 horas',
                  value: ''
                }, {
                  label: '✅ Más de 1.144 personas ya activaron su conjuro con éxito',
                  value: ''
                }]} data-id="element-70" />
                </Box>

                <Text fontSize="xl" fontWeight="bold" color="red.300" textAlign="center" mt={4} data-id="element-71">
                  Cuando funciona… La persona piensa en ti. Te busca. Te desea.
                  Y vuelve.
                </Text>
              </VStack>
            </Box>

            {/* NEW SECTION — VIDEO DE MAESTROS DEL CONOCIMIENTO (TikTok Format) */}
            <Box bg="linear-gradient(135deg, #000000 0%, #1F1F1F 100%)" p={8} borderRadius="xl" shadow="2xl" borderWidth="2px" borderColor="red.600" data-id="element-72">
              <VStack spacing={6} align="stretch" data-id="element-73">
                <Heading as="h2" fontSize={{
                base: '2xl',
                md: '3xl'
              }} color="white" textAlign="center" fontWeight="black" data-id="element-74">
                  🎓 HASTA LOS MEJORES MAESTROS DEL CONOCIMIENTO LO HAN
                  COMPROBADO
                </Heading>

                {/* TikTok-style vertical video container */}
                <Flex justify="center" w="full" data-id="element-75">
                  <Box w="full" maxW={{
                  base: '100%',
                  sm: '400px',
                  md: '450px'
                }} bg="linear-gradient(135deg, rgba(127, 29, 29, 0.3) 0%, rgba(0, 0, 0, 0.5) 100%)" p={4} borderRadius="xl" borderWidth="2px" borderColor="red.500" shadow="2xl" data-id="element-76">
                    <Box as="video" controls playsInline webkit-playsinline="true" preload="metadata" w="full" borderRadius="lg" sx={{
                    aspectRatio: '9/16',
                    objectFit: 'cover',
                    '&::-webkit-media-controls-fullscreen-button': {
                      display: 'none'
                    },
                    '&::-webkit-media-controls-enclosure': {
                      overflow: 'hidden'
                    }
                  }} data-id="element-77">
                      <source src="https://ydgkmdmvhrniztrhtrxq.supabase.co/storage/v1/object/sign/audio%20receta/pikaso-untitled-project-2026-02-23%20(1).mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV80NDNkYTY1ZS1iYWM1LTQyYWQtODMzNS1iNWE4N2M0NDYxNmQiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJhdWRpbyByZWNldGEvcGlrYXNvLXVudGl0bGVkLXByb2plY3QtMjAyNi0wMi0yMyAoMSkubXA0IiwiaWF0IjoxNzcxODU3OTQ2LCJleHAiOjE4MDMzOTM5NDZ9.EofhzdCNH5ECQd6dc9yzb8ZWU5wrh0Us1Br2KLE_y_w" type="video/mp4" data-id="element-78" />
                      Tu navegador no soporta el elemento de video.
                    </Box>
                  </Box>
                </Flex>

                <Box bg="rgba(220, 38, 38, 0.2)" p={6} borderRadius="lg" borderWidth="2px" borderColor="red.500" textAlign="center" data-id="element-79">
                  <Text fontSize="lg" color="yellow.300" fontWeight="bold" mb={2} data-id="element-80">
                    ✨ El poder del conocimiento ancestral
                  </Text>
                  <Text fontSize="md" color="gray.300" lineHeight="tall" data-id="element-81">
                    Los grandes maestros espirituales han validado la
                    efectividad de estos rituales milenarios. No es magia, es
                    sabiduría ancestral aplicada con intención pura.
                  </Text>
                </Box>
              </VStack>
            </Box>

            {/* BLOQUE 4 — PORTADA DEL E-BOOK + OFERTA (REORGANIZED) */}
            <Box bg="linear-gradient(135deg, #000000 0%, #1F1F1F 100%)" p={8} borderRadius="xl" shadow="2xl" borderWidth="2px" borderColor="red.600" data-id="element-82">
              <VStack spacing={8} align="stretch" data-id="element-83">
                <Heading as="h2" fontSize={{
                base: '2xl',
                md: '3xl'
              }} color="white" textAlign="center" data-id="element-84">
                  🔮 Lo que estás a punto de tener en tus manos:
                </Heading>

                {/* Title Above the Box */}
                <Heading as="h3" fontSize={{
                base: 'xl',
                md: '2xl'
              }} color="white" fontWeight="black" textAlign="center" mb={-4} data-id="element-85">
                  CONJURO DE LOS 7 PODERES ANCESTRALES DEL AMOR
                </Heading>

                {/* E-Book Cover Image Inside Box */}
                <Box bg="linear-gradient(135deg, #7F1D1D 0%, #000000 100%)" p={8} borderRadius="xl" textAlign="center" shadow="2xl" borderWidth="2px" borderColor="red.500" display="flex" justifyContent="center" alignItems="center" data-id="element-86">
                  <Image src="https://cdn.magicpatterns.com/uploads/iBBXsqZKKdmt6GDk3Sbj5i/heylloyd-image-1771855098992.png" alt="El Conjuro de los 7 Poderes Ancestrales del Amor - E-Book Digital" maxW={{
                  base: '100%',
                  md: '400px'
                }} w="full" h="auto" borderRadius="lg" shadow="2xl" objectFit="contain" data-id="element-87" />
                </Box>

                <Badge bg="yellow.400" color="black" fontSize="md" px={4} py={2} borderRadius="full" alignSelf="center" data-id="element-88">
                  ✨ Guía Digital — Descarga Inmediata
                </Badge>

                <Heading as="h3" fontSize="2xl" color="white" textAlign="center" data-id="element-89">
                  💰 TU INVERSIÓN HOY:
                </Heading>

                <PricingTable rows={[{
                label: 'Precio original',
                value: <Text textDecoration="line-through" color="gray.500" fontWeight="bold" data-id="element-91">
                          $20.00 USD
                        </Text>
              }, {
                label: '🔥 Precio especial HOY',
                value: <Text color="yellow.300" fontSize="2xl" fontWeight="black" data-id="element-92">
                          $9.99 USD
                        </Text>
              }, {
                label: 'Ahorro real',
                value: <Text color="red.400" fontWeight="bold" data-id="element-93">
                          $10.01 USD — 50% de descuento
                        </Text>
              }, {
                label: 'Formato',
                value: '📱 E-Book Digital — Acceso instantáneo'
              }, {
                label: 'Entrega',
                value: '⚡ Automática vía Shopify'
              }, {
                label: 'Pago seguro',
                value: '💳 Tarjeta débito o crédito'
              }]} data-id="element-90" />

                {/* Green CTA Button */}
                <CTAButton onClick={handleCTAClick} bg="linear-gradient(135deg, #10B981 0%, #059669 100%)" color="white" borderColor="green.400" shadow="0 0 30px rgba(16, 185, 129, 0.6), 0 8px 16px rgba(0, 0, 0, 0.3)" _hover={{
                bg: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                transform: 'scale(1.05)',
                shadow: '0 0 40px rgba(16, 185, 129, 0.8), 0 12px 24px rgba(0, 0, 0, 0.4)',
                borderColor: 'green.300'
              }} _active={{
                bg: 'linear-gradient(135deg, #047857 0%, #065f46 100%)',
                transform: 'scale(0.98)'
              }} fontSize={{
                base: 'sm',
                md: 'lg'
              }} fontWeight="black" textTransform="uppercase" letterSpacing="wide" data-id="element-94">
                  ✅ SÍ, QUIERO MI GUÍA AHORA — $9.99 USD
                </CTAButton>

                <Box bg="rgba(127, 29, 29, 0.3)" p={6} borderRadius="lg" borderLeftWidth="4px" borderLeftColor="red.500" data-id="element-95">
                  <Text fontWeight="bold" color="red.300" mb={2} data-id="element-96">
                    ⚠️ IMPORTANTE:
                  </Text>
                  <Text color="gray.300" lineHeight="tall" data-id="element-97">
                    Este precio de $9.99 USD no es permanente. Existe porque
                    queremos que esta guía llegue a las personas que realmente
                    la necesitan — no para siempre. Cuando el contador llegue a
                    cero, el precio vuelve a $20 USD sin excepciones.
                  </Text>
                </Box>

                <HStack justify="center" spacing={4} flexWrap="wrap" data-id="element-98">
                  <HStack spacing={2} data-id="element-99">
                    <LockIcon size={16} color="#10B981" data-id="element-100" />
                    <Text fontSize="sm" color="gray.400" data-id="element-101">
                      Pago 100% seguro
                    </Text>
                  </HStack>
                  <HStack spacing={2} data-id="element-102">
                    <ZapIcon size={16} color="#10B981" data-id="element-103" />
                    <Text fontSize="sm" color="gray.400" data-id="element-104">
                      Entrega inmediata
                    </Text>
                  </HStack>
                  <HStack spacing={2} data-id="element-105">
                    <Text fontSize="sm" color="gray.400" data-id="element-106">
                      🛡️ Garantía 7 días
                    </Text>
                  </HStack>
                </HStack>
              </VStack>
            </Box>

            {/* BLOQUE 5 — QUÉ INCLUYE LA GUÍA */}
            <Box bg="linear-gradient(135deg, #1F1F1F 0%, #000000 100%)" p={8} borderRadius="xl" shadow="2xl" borderWidth="1px" borderColor="red.900" data-id="element-107">
              <VStack spacing={6} align="stretch" data-id="element-108">
                <Heading as="h2" fontSize={{
                base: '2xl',
                md: '3xl'
              }} color="white" data-id="element-109">
                  📦 ✨ Dentro del E-Book encontrarás:
                </Heading>

                <PricingTable rows={[{
                label: '📖 El ritual completo paso a paso',
                value: 'Para que no tengas dudas en ningún momento'
              }, {
                label: '🌿 Lista de materiales caseros',
                value: 'Sin gastos extras ni búsquedas complicadas'
              }, {
                label: '🔥 Protocolo de activación energética',
                value: 'El núcleo que despierta la conexión real'
              }, {
                label: '💫 Guía de intención y enfoque mental',
                value: 'Para potenciar el resultado al máximo'
              }, {
                label: '🎯 Instrucciones para los 3 escenarios',
                value: 'Recuperar / Fortalecer / Atraer un nuevo amor'
              }]} data-id="element-110" />

                <Divider borderColor="red.900" data-id="element-111" />

                <Heading as="h3" fontSize="xl" color="white" data-id="element-112">
                  🔥 Esta guía fue diseñada para ti si deseas:
                </Heading>

                <PricingTable rows={[{
                label: '💔 Tu ex no da señales',
                value: 'Que vuelva a pensar en ti y te busque'
              }, {
                label: '💑 Tu relación perdió la chispa',
                value: 'Reavivar la conexión y el deseo'
              }, {
                label: '🌹 Quieres atraer un amor nuevo',
                value: 'Abrir tu campo energético al amor'
              }]} data-id="element-113" />
              </VStack>
            </Box>

            {/* BLOQUE 6 — TESTIMONIOS REALES */}
            <Box bg="linear-gradient(135deg, #7F1D1D 0%, #000000 100%)" p={8} borderRadius="xl" borderWidth="1px" borderColor="red.700" data-id="element-114">
              <VStack spacing={8} align="stretch" data-id="element-115">
                <Heading as="h2" fontSize={{
                base: '2xl',
                md: '3xl'
              }} color="white" textAlign="center" data-id="element-116">
                  💬 Las palabras de ellos valen más que las nuestras:
                </Heading>

                <Stack spacing={6} direction={{
                base: 'column',
                lg: 'row'
              }} data-id="element-117">
                  <TestimonialCard rating={5} text="Llevaba 3 meses sin saber nada de él. Lo di por perdido. Hice el conjuro un domingo por la noche y el martes me escribió diciendo que no podía dejar de pensar en mí. Todavía no lo creo." author="Valentina R." location="Colombia" avatarUrl="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop" data-id="element-118" />
                  <TestimonialCard rating={5} text="Yo soy muy escéptica con estas cosas, pero estaba desesperada. Lo hice sin mucha fe y al tercer día me llamó llorando pidiéndome otra oportunidad. Llevábamos 5 meses separados." author="Mariana G." location="Ciudad de México, México" avatarUrl="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop" data-id="element-119" />
                </Stack>

                <Stack spacing={6} direction={{
                base: 'column',
                lg: 'row'
              }} data-id="element-120">
                  <TestimonialCard rating={5} text="Mi relación estaba completamente fría. Sin peleas pero sin amor. Hice el conjuro con intención de reavivar lo que teníamos y en menos de una semana volvimos a ser los de antes. Como si algo se hubiera despertado en él." author="Lorena P." location="Argentina" avatarUrl="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop" data-id="element-121" />
                  <TestimonialCard rating={5} text="Pensé que era tarde. Que ya había perdido su amor para siempre. Pero hice el ritual con fe y en 2 días empezó a buscarme. Hoy estamos juntos de nuevo y más fuertes que antes." author="Daniela M." location="Venezuela" avatarUrl="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop" data-id="element-122" />
                </Stack>

                <Stack spacing={6} direction={{
                base: 'column',
                lg: 'row'
              }} data-id="element-123">
                  <TestimonialCard rating={5} text="Después de 6 meses de separación, pensé que todo estaba perdido. Hice el conjuro con el corazón abierto y en menos de 72 horas me buscó. Ahora estamos reconstruyendo nuestra relación más fuertes que nunca." author="Carmen S." location="Guadalajara, México" avatarUrl="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop" data-id="element-124" />
                  <TestimonialCard rating={5} text="I was skeptical at first, but desperate. I followed every step carefully and within 4 days he reached out. We're now working things out and I couldn't be happier. This really works!" author="Sarah M." location="Miami, Estados Unidos" avatarUrl="https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop" data-id="element-125" />
                </Stack>

                <Stack spacing={6} direction={{
                base: 'column',
                lg: 'row'
              }} data-id="element-126">
                  <TestimonialCard rating={5} text="No creía en estas cosas pero estaba desesperado. Lo hice exactamente como dice la guía y al segundo día ella me escribió. Llevábamos 4 meses sin hablar. Gracias de corazón." author="Roberto L." location="Monterrey, México" avatarUrl="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop" data-id="element-127" />
                  <TestimonialCard rating={5} text="This ritual changed everything for me. After 8 months apart, I thought it was over. Did the ritual on a Friday night and by Monday morning she called me crying. We're back together now." author="Michael R." location="New York, Estados Unidos" avatarUrl="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop" data-id="element-128" />
                </Stack>

                <TestimonialCard rating={5} text="No voy a entrar en detalles por privacidad, pero lo que puedo decir es que funcionó más rápido de lo que esperaba. Al segundo día ya tenía señales claras. Gracias desde el fondo de mi corazón." author="Usuario anónimo" location="España" avatarUrl="https://images.unsplash.com/photo-1511367461989-f85a21fda167?w=150&h=150&fit=crop" data-id="element-129" />

                <Box bg="rgba(0, 0, 0, 0.6)" p={6} borderRadius="lg" shadow="xl" borderWidth="1px" borderColor="red.800" data-id="element-130">
                  <Heading as="h3" fontSize="xl" color="white" mb={4} textAlign="center" data-id="element-131">
                    🔢 Los números no mienten:
                  </Heading>
                  <PricingTable rows={[{
                  label: '👥 Personas que aplicaron el conjuro',
                  value: '+1.144'
                }, {
                  label: '⭐ Calificación promedio',
                  value: '4.9 / 5'
                }, {
                  label: '💬 Testimonios recibidos',
                  value: '+1.000'
                }, {
                  label: '⚡ Tiempo promedio para primeras señales',
                  value: '48–72 horas'
                }]} data-id="element-132" />
                </Box>
              </VStack>
            </Box>

            {/* BLOQUE 7 — PARA QUIÉN ES Y PARA QUIÉN NO */}
            <Box bg="linear-gradient(135deg, #000000 0%, #1F1F1F 100%)" p={8} borderRadius="xl" shadow="2xl" borderWidth="1px" borderColor="red.900" data-id="element-133">
              <VStack spacing={8} align="stretch" data-id="element-134">
                <Heading as="h2" fontSize={{
                base: '2xl',
                md: '3xl'
              }} color="white" textAlign="center" data-id="element-135">
                  🎯 ¿Es este conjuro para ti?
                </Heading>

                <Box bg="rgba(5, 150, 105, 0.1)" p={6} borderRadius="lg" borderWidth="2px" borderColor="green.700" data-id="element-136">
                  <Heading as="h3" fontSize="xl" color="green.300" mb={4} data-id="element-137">
                    🔮 Este conjuro ES para ti si:
                  </Heading>
                  <VStack spacing={3} align="stretch" data-id="element-138">
                    <HStack spacing={3} align="start" data-id="element-139">
                      <CheckIcon size={20} color="#10B981" strokeWidth={3} data-id="element-140" />
                      <Text color="gray.300" data-id="element-141">
                        Amas genuinamente a esa persona
                      </Text>
                    </HStack>
                    <HStack spacing={3} align="start" data-id="element-142">
                      <CheckIcon size={20} color="#10B981" strokeWidth={3} data-id="element-143" />
                      <Text color="gray.300" data-id="element-144">
                        Quieres que vuelva desde el deseo real, no desde la
                        obligación
                      </Text>
                    </HStack>
                    <HStack spacing={3} align="start" data-id="element-145">
                      <CheckIcon size={20} color="#10B981" strokeWidth={3} data-id="element-146" />
                      <Text color="gray.300" data-id="element-147">
                        Buscas una conexión auténtica y duradera
                      </Text>
                    </HStack>
                    <HStack spacing={3} align="start" data-id="element-148">
                      <CheckIcon size={20} color="#10B981" strokeWidth={3} data-id="element-149" />
                      <Text color="gray.300" data-id="element-150">
                        Estás dispuesto/a a asumir la responsabilidad del ritual
                      </Text>
                    </HStack>
                    <HStack spacing={3} align="start" data-id="element-151">
                      <CheckIcon size={20} color="#10B981" strokeWidth={3} data-id="element-152" />
                      <Text color="gray.300" data-id="element-153">
                        Tu intención nace del amor, no del dolor
                      </Text>
                    </HStack>
                  </VStack>
                </Box>

                <Box bg="rgba(127, 29, 29, 0.2)" p={6} borderRadius="lg" borderWidth="2px" borderColor="red.700" data-id="element-154">
                  <Heading as="h3" fontSize="xl" color="red.300" mb={4} data-id="element-155">
                    ⛔ NO compres si:
                  </Heading>
                  <VStack spacing={3} align="stretch" data-id="element-156">
                    <HStack spacing={3} align="start" data-id="element-157">
                      <XIcon size={20} color="#DC2626" strokeWidth={3} data-id="element-158" />
                      <Text color="gray.300" data-id="element-159">
                        No sientes amor real por esa persona
                      </Text>
                    </HStack>
                    <HStack spacing={3} align="start" data-id="element-160">
                      <XIcon size={20} color="#DC2626" strokeWidth={3} data-id="element-161" />
                      <Text color="gray.300" data-id="element-162">
                        Lo harías solo por curiosidad o capricho
                      </Text>
                    </HStack>
                    <HStack spacing={3} align="start" data-id="element-163">
                      <XIcon size={20} color="#DC2626" strokeWidth={3} data-id="element-164" />
                      <Text color="gray.300" data-id="element-165">
                        Tu intención es manipular o controlar
                      </Text>
                    </HStack>
                    <HStack spacing={3} align="start" data-id="element-166">
                      <XIcon size={20} color="#DC2626" strokeWidth={3} data-id="element-167" />
                      <Text color="gray.300" data-id="element-168">
                        Te mueve el rencor, la rabia o la venganza
                      </Text>
                    </HStack>
                  </VStack>
                </Box>

                <Box bg="rgba(220, 38, 38, 0.2)" p={6} borderRadius="lg" borderWidth="2px" borderColor="red.600" data-id="element-169">
                  <Text fontWeight="bold" color="red.300" fontSize="lg" mb={2} data-id="element-170">
                    🚨 ADVERTENCIA SERIA:
                  </Text>
                  <Text color="gray.300" lineHeight="tall" data-id="element-171">
                    Este no es un ritual simbólico ni un producto decorativo.
                    Trabaja a nivel energético profundo y genera consecuencias
                    reales. Hemos comprobado que cuando se usa con intención
                    incorrecta, el poder regresa multiplicado hacia quien lo
                    realiza. Úsalo solo si tu corazón está en el lugar correcto.
                  </Text>
                </Box>
              </VStack>
            </Box>

            {/* BLOQUE 8 — GARANTÍA + PROCESO DE ENTREGA */}
            <Box bg="linear-gradient(135deg, #1F1F1F 0%, #000000 100%)" p={8} borderRadius="xl" shadow="2xl" borderWidth="1px" borderColor="red.900" data-id="element-172">
              <VStack spacing={8} align="stretch" data-id="element-173">
                <Heading as="h2" fontSize={{
                base: '2xl',
                md: '3xl'
              }} color="white" textAlign="center" data-id="element-174">
                  🛡️ Tu compra no tiene ningún riesgo:
                </Heading>

                <GuaranteeSection data-id="element-175" />

                <Divider borderColor="red.900" data-id="element-176" />

                <Heading as="h3" fontSize="xl" color="white" textAlign="center" data-id="element-177">
                  ⚡ ¿Cómo recibes tu guía?
                </Heading>

                <PricingTable rows={[{
                label: '1️⃣ Haces clic en "Comprar Ahora"',
                value: 'Entras al proceso de pago seguro'
              }, {
                label: '2️⃣ Completas el pago',
                value: 'Tarjeta débito o crédito — 100% seguro'
              }, {
                label: '3️⃣ Shopify confirma automáticamente',
                value: 'En segundos'
              }, {
                label: '4️⃣ Recibes tu correo de acceso',
                value: 'Con link de descarga inmediata'
              }, {
                label: '5️⃣ Abres la guía y empiezas hoy',
                value: 'El ritual puede comenzar esta misma noche'
              }]} data-id="element-178" />
              </VStack>
            </Box>

            {/* BLOQUE 9 — CTA FINAL + CIERRE EMOCIONAL */}
            <Box bg="linear-gradient(135deg, #7F1D1D 0%, #000000 100%)" p={8} borderRadius="xl" shadow="2xl" borderWidth="2px" borderColor="red.600" data-id="element-179">
              <VStack spacing={8} align="stretch" data-id="element-180">
                <Heading as="h2" fontSize={{
                base: '2xl',
                md: '4xl'
              }} color="white" textAlign="center" fontWeight="black" data-id="element-181">
                  Esta es la decisión más importante que tomarás hoy.
                </Heading>

                <Text fontSize="lg" color="red.100" textAlign="center" lineHeight="tall" data-id="element-182">
                  No por el dinero. Nueve dólares con noventa y nueve centavos
                  no cambian tu vida.
                </Text>

                <Text fontSize="xl" fontWeight="bold" color="yellow.300" textAlign="center" data-id="element-183">
                  Pero lo que está dentro de esta guía… sí puede hacerlo.
                </Text>

                <Text fontSize="md" color="gray.300" textAlign="center" lineHeight="tall" data-id="element-184">
                  Puedes cerrar esta página. Seguir esperando. Seguir revisando
                  su perfil. Seguir cargando ese peso.
                </Text>

                <Text fontSize="lg" color="white" textAlign="center" lineHeight="tall" fontWeight="semibold" data-id="element-185">
                  O puedes hacer algo diferente hoy. Algo que más de 1.144
                  personas ya hicieron y que cambió el rumbo de su historia de
                  amor.
                </Text>

                <Box bg="rgba(0, 0, 0, 0.6)" p={6} borderRadius="lg" borderWidth="2px" borderColor="red.500" data-id="element-186">
                  <Text fontSize="xl" fontWeight="bold" color="white" textAlign="center" data-id="element-187">
                    El amor que deseas no desapareció. Solo necesita que alguien
                    lo despierte. Ese alguien eres tú.
                  </Text>
                </Box>

                <CTAButton onClick={handleCTAClick} bg="yellow.400" color="black" _hover={{
                bg: 'yellow.500'
              }} data-id="element-188">
                  🔮 SÍ — QUIERO ACTIVAR MI CONJURO AHORA POR $9.99 USD
                </CTAButton>

                <HStack justify="center" spacing={4} flexWrap="wrap" data-id="element-189">
                  <HStack spacing={2} data-id="element-190">
                    <LockIcon size={16} color="white" data-id="element-191" />
                    <Text fontSize="sm" color="white" data-id="element-192">
                      Pago seguro
                    </Text>
                  </HStack>
                  <Text fontSize="sm" color="white" data-id="element-193">
                    ·
                  </Text>
                  <HStack spacing={2} data-id="element-194">
                    <ZapIcon size={16} color="white" data-id="element-195" />
                    <Text fontSize="sm" color="white" data-id="element-196">
                      Acceso inmediato
                    </Text>
                  </HStack>
                  <Text fontSize="sm" color="white" data-id="element-197">
                    ·
                  </Text>
                  <Text fontSize="sm" color="white" data-id="element-198">
                    🛡️ Garantía 7 días
                  </Text>
                  <Text fontSize="sm" color="white" data-id="element-199">
                    ·
                  </Text>
                  <Text fontSize="sm" color="white" data-id="element-200">
                    💳 Débito o crédito
                  </Text>
                </HStack>

                <Text fontSize="xl" fontStyle="italic" color="yellow.200" textAlign="center" fontWeight="semibold" mt={4} data-id="element-201">
                  "No dejes que el miedo a creer sea más grande que tu deseo de
                  amar."
                </Text>
              </VStack>
            </Box>

            {/* Footer */}
            <Box textAlign="center" py={8} data-id="element-202">
              <Text fontSize="sm" color="gray.600" data-id="element-203">
                © 2024 Conjuro de los 7 Poderes Ancestrales del Amor. Todos los
                derechos reservados.
              </Text>
            </Box>
          </VStack>
        </Container>
      </Box>
    </ChakraProvider>;
}